import { Button, openInNewTab } from '@sandtech-hub-monorepo/ui-kit';
import { ClassEnrollmentStatus } from '@sandtech-hub-monorepo/ehub-client';

const getButtonType = (
  status: ClassEnrollmentStatus | null | undefined
): {
  variant:
    | 'link'
    | 'default'
    | 'destructive'
    | 'outlineDestructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | null
    | undefined;
  buttonText: string;
  disabled: boolean;
} => {
  switch (status) {
    case 'ONGOING':
      return {
        variant: 'default',
        buttonText: 'Continue',
        disabled: false,
      };
    case 'LEAVE_OF_ABSENCE':
      return {
        variant: 'outline',
        buttonText: 'Paused',
        disabled: true,
      };
    case 'DEFERRED':
      return {
        variant: 'outline',
        buttonText: 'Deferred',
        disabled: true,
      };
    case 'FAILED':
      return {
        variant: 'outline',
        buttonText: 'Continue',
        disabled: false,
      };
    case 'GRADUATED':
      return {
        variant: 'outline',
        buttonText: 'Continue',
        disabled: false,
      };
    case null:
      return {
        variant: 'default',
        buttonText: 'Not available',
        disabled: true,
      };
    case undefined:
      return {
        variant: 'default',
        buttonText: 'Not available',
        disabled: true,
      };
    default:
      return {
        variant: 'default',
        buttonText: 'Continue',
        disabled: true,
      };
  }
};

export const PlannedCourseButton = ({
  status,
  link,
}: {
  status: ClassEnrollmentStatus | null | undefined;
  link: string;
}) => {
  return (
    <Button
      className="w-full sm:w-[initial] sm:px-6 my-auto"
      variant={getButtonType(status).variant}
      disabled={getButtonType(status).disabled}
      onClick={() => openInNewTab(link)}
    >
      {getButtonType(status).buttonText}
    </Button>
  );
};
